import _ from 'lodash';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useDateParam = () => {
	let date = new URLSearchParams(useLocation().search).get('date');
	date = date ? parseInt(date) : new Date();
	return date;
};

export const useMenu = () => {
	const menus = useMenus();
	const isOpen = menus.isOpen?.menu == true;
	const anchor = menus.anchors?.menu;

	const open = (el) => {
		menus.open('menu', el);
	};
	const close = () => {
		menus.close();
	};

	return { isOpen, open, close, anchor };
}

export const useMenus = () => {
	const [anchors, setAnchors] = useState({});
	const isOpen = _.mapValues(anchors, anchor => { return anchor != null });

	const open = (menu, el) => {
		el = el.currentTarget ? el.currentTarget : el;
		anchors[menu] = el;
		setAnchors({ ...anchors });
	};
	const close = () => {
		setAnchors({});
	};

	return { anchors, setAnchors, isOpen, open, close };
}

export const useDialogs = (arr) => {
	const [data, setData] = useState(null);
	const [isOpen, setOpen] = useState({});
	const [isSaving, setSaving] = useState({});

	const open = (dialog, dialogData) => {
		if (dialogData) {
			setData(dialogData);
		}
		isOpen[dialog] = true;
		setOpen({ ...isOpen });
	};
	const close = (dialog) => {
		if (dialog && typeof isOpen[dialog] !== 'undefined') {
			isOpen[dialog] = false;
			setOpen({ ...isOpen });
		}
		else {
			setOpen({});
		}
	};

	const saving = (dialog) => {
		isSaving[dialog] = true;
		setSaving({ ...isSaving });
	};
	const saved = (dialog) => {
		if (dialog && typeof isSaving[dialog] !== 'undefined') {
			isSaving[dialog] = false;
			setSaving({ ...isSaving });
		}
		else {
			setSaving({});
		}
	};

	const onSubmit = (results, arrayOverride = arr, callback) => {
		close();
		if (!_.isArray(results)) {
			results = [results];
		}
		results.forEach(result => {
			result = _.omitBy(result, _.isNil);
			let existing = _.find(arrayOverride, { id: result.id });
			if (existing) {
				Object.assign(existing, result);
			}
			else {
				arrayOverride?.push(result);
			}
		});
		callback?.(results);
	};

	return { data, setData, isOpen, setOpen, isSaving, setSaving, open, close, saving, saved, onSubmit };
};
